export enum StatusEnum {
  Active = 1,
  Inactive = 0,
}
